export default {
      id: "search-usage",
      viewBox: "0 0 487.95 487.95",
      url: "/dist/svg/" + "sprite.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }